export class PageBackgroundImageAction {
  static readonly type = '[Page Background Image] PageBackgroundImageAction';
}

export class PageBackgroundImageSelected {
  static readonly type = '[Page Background Image] PageBackgroundImageSelected';
  constructor(public src: string) {}
}

export class UpdatePageConfigurationAction {
  static readonly type = '[Page Configuration] UpdatePageConfigurationAction';
}
